import React, { Component } from 'react';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { SEARCH_API } from '../../utils/constants';
import { track } from '../atlas-link';
import './search-field.less';

interface Props {
    className?: string;
    productVersion: string;
    productName: string;
    placeholder?: string;
}

interface State {
    value: string;
}

export default class SearchField extends Component<Props, State> {
    static defaultProps = {
        productVersion: '',
        productName: '',
        placeholder: 'Search documentation'
    };

    state = {
        value: ''
    };

    // Navigate to CAC search with searchTerm
    search = (value: string) => {
        const { productName, productVersion } = this.props;
        const productNameParam = productName
            ? `&productName=${productName.replace(/\s/g, '+')}`
            : '';
        const productVersionParam = productVersion
            ? `&productVersion=${productVersion}`
            : '';

        const encodedUrl = `${SEARCH_API}?query=${encodeURIComponent(
            value
        )}${productNameParam}${productVersionParam}`;
        track(encodedUrl, 'Search', 'search button');
        // @ts-ignore
        if (window.Cypress) {
            window.open(encodedUrl, '_self');
        } else {
            window.open(encodedUrl, '_blank');
        }
    };

    handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = evt.target;
        this.setState({ value });
    };

    handleKeyUp = (evt: React.KeyboardEvent) => {
        const { value } = this.state;
        if (evt.keyCode === 13) {
            this.search(value);
        }
    };

    render() {
        const { value } = this.state;
        const { placeholder } = this.props;

        return (
            <div className={['search-field', this.props.className].join(' ')}>
                <input
                    aria-label="Search site content"
                    className="search-field__input"
                    type="search"
                    name="query"
                    placeholder={placeholder}
                    value={value}
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                />
                <div
                    data-testid="search_icon"
                    className="search-field__icon"
                    role="button"
                    aria-label="Search site content"
                    tabIndex={0}
                    onClick={() => this.search(value)}
                    onKeyUp={this.handleKeyUp}
                >
                    <SearchIcon label="Search" />
                </div>
            </div>
        );
    }
}
